module.exports = "pegasus/assets/l_d.png";